import React from 'react';

const HorizontalPump4Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 72.525"
      className={className}
    >

<g id={`${uid}_1`}>
	
		<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="58.4463" y1="18.0193" x2="58.4463" y2="62.9514" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} stroke={`${startColor}`} strokeWidth="0.25" d="M103.491,54.506H85.473v-4.505h-49.55v-2.252H11.261v-2.252   H8.896v-2.252H4.392V20.722h4.504v-2.253h2.365v-2.252h24.662v-2.252h49.55V9.574h18.019v11.148h6.757v-4.505h2.252v31.531h-2.252   v-4.504h-6.757V54.506" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M8.896,43.245V20.722" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M11.261,18.469v27.027" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M35.923,47.749V16.218" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M85.473,13.965v36.036" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M103.491,20.722v22.522" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M110.248,20.722v22.522" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M89.979,9.574v44.932" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M87.725,9.574v44.932" />
</g>
<g id={`${uid}_3`}>
	
		<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="89.9785" y1="66.0476" x2="103.4922" y2="66.0476" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.979,3.38h13.514v6.194H89.979V3.38z" />
	
		<linearGradient id={`${uid}_5`} gradientUnits="userSpaceOnUse" x1="85.4727" y1="70.8347" x2="107.9961" y2="70.8347" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_5)`} stroke={`${startColor}`} strokeWidth="0.25" d="M85.473,0.001h22.523V3.38H85.473V0.001" />
</g>
<g id={`${uid}_6`}>
	
		<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="42.7358" y1="40.5417" x2="42.7358" y2="71.9607" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_7)`} stroke={`${startColor}`} strokeWidth="0.25" d="M4.392,29.731H2.14V11.713h81.081V2.704h2.252v-2.14h-4.504   v9.009H0v22.41h4.392V29.731z" />
</g>
<g id={`${uid}_8`}>
	
		<linearGradient id={`${uid}_9`} gradientUnits="userSpaceOnUse" x1="15.7661" y1="36.5999" x2="29.167" y2="36.5999" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_9)`} stroke={`${startColor}`} strokeWidth="0.25" d="M15.766,31.983h6.644v-3.378h6.757v3.378v11.262H15.766   V31.983z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M13.401,54.506V31.983h9.009v-3.378h6.757" />
	
		<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="17.9048" y1="33.7849" x2="31.4189" y2="33.7849" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} d="M19.82,43.583l-1.915-4.843l1.915-4.842l4.842-1.915l4.842,1.915l1.915,4.842l-1.915,4.843   l-4.842,1.914L19.82,43.583z" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M29.504,33.898l2.027,4.842l-2.027,4.843l-4.729,1.914l-4.842-1.914" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M27.14,36.263l1.014,2.478l-1.014,2.478l-2.365,0.9l-2.478-0.9" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M22.297,41.218l-1.014-2.478l1.014-2.365l2.365-1.014l2.478,1.014" />
</g>
<g id={`${uid}_11`}>
	<path fill={`${startColor}`} d="M20.721,34.799h1.126v1.126h-1.126V34.799z" />
	<path fill={`${startColor}`} d="M20.721,41.556h1.126v1.126h-1.126V41.556z" />
	<path fill={`${startColor}`} d="M27.478,41.556h1.126v1.126h-1.126V41.556z" />
	<path fill={`${startColor}`} d="M27.478,34.799h1.126v1.126h-1.126V34.799z" />
	<path fill={`${startColor}`} d="M84.348,11.263h1.125v1.014h-1.125V11.263z" />
	<path fill={`${startColor}`} d="M84.348,15.767h1.125v1.014h-1.125V15.767z" />
	<path fill={`${startColor}`} d="M84.348,20.159h1.125v1.126h-1.125V20.159z" />
	<path fill={`${startColor}`} d="M84.348,24.664h1.125v1.126h-1.125V24.664z" />
	<path fill={`${startColor}`} d="M84.348,29.168h1.125v1.126h-1.125V29.168z" />
	<path fill={`${startColor}`} d="M84.348,33.673h1.125v1.126h-1.125V33.673z" />
	<path fill={`${startColor}`} d="M84.348,38.177h1.125v1.128h-1.125V38.177z" />
	<path fill={`${startColor}`} d="M84.348,42.682h1.125v1.126h-1.125V42.682z" />
	<path fill={`${startColor}`} d="M84.348,47.187h1.125v1.126h-1.125V47.187z" />
	<path fill={`${startColor}`} d="M84.348,51.69h1.125v1.127h-1.125V51.69z" />
	<path fill={`${startColor}`} d="M7.883,42.682h1.014v1.126H7.883V42.682z" />
	<path fill={`${startColor}`} d="M7.883,38.177h1.014v1.128H7.883V38.177z" />
	<path fill={`${startColor}`} d="M7.883,33.673h1.014v1.126H7.883V33.673z" />
	<path fill={`${startColor}`} d="M7.883,29.168h1.014v1.126H7.883V29.168z" />
	<path fill={`${startColor}`} d="M7.883,24.664h1.014v1.126H7.883V24.664z" />
	<path fill={`${startColor}`} d="M7.883,20.159h1.014v1.126H7.883V20.159z" />
</g>
<g id={`${uid}_12`}>
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M15.766,54.506h-2.365V31.983h2.365V54.506z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M76.464,31.983h2.253v22.521h-2.253V31.983z" />
	
		<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="15.6528" y1="16.8928" x2="20.1572" y2="16.8928" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} stroke={`${startColor}`} strokeWidth="0.25" d="M15.653,47.749h4.504v15.767h-4.504V47.749z" />
	
		<linearGradient id={`${uid}_14`} gradientUnits="userSpaceOnUse" x1="78.7168" y1="15.7668" x2="83.2207" y2="15.7668" gradientTransform="matrix(1 0 0 -1 0 72.5249)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_14)`} stroke={`${startColor}`} strokeWidth="0.25" d="M78.717,50.001h4.504v13.515h-4.504V50.001z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M13.401,65.767h90.09v4.506h-90.09V65.767z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M83.221,63.515V52.254l4.504,11.262H83.221z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M20.158,63.515V52.254l4.504,11.262H20.158z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M11.261,63.515h94.482v2.252H11.261V63.515z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M11.261,70.272h94.482v2.252H11.261V70.272z" />
</g>
    </svg>
  );
};

export default HorizontalPump4Icon;
